import _ from 'underscore'
import $ from 'jquery'
import messageResource from '../../messageResource'
import InviteSeveralUsersRow from './InviteSeveralUsersRow'

function ATInviteSeveralUsersRow(){}

ATInviteSeveralUsersRow.prototype = _.create(InviteSeveralUsersRow.prototype, {
    CONCURRENTLY_DELETED_TEMPLATE_ERROR: "concurrentlyDeletedTemplateError",

    init: function(rowNumber, specialRowClasses, validationCallback, changesCallback, templatesDropdownList,
                   defaultPermissionsTemplateId, defaultPermissionsTemplateName, errorTooltip)
    {
        this.templatesDropdownList = templatesDropdownList;
        this.permissionsTemplateId = defaultPermissionsTemplateId;
        this.defaultPermissionsTemplateId = defaultPermissionsTemplateId;
        this.permissionsTemplateName = defaultPermissionsTemplateName;

        InviteSeveralUsersRow.prototype.init.call(this, rowNumber, specialRowClasses, validationCallback, changesCallback, errorTooltip);

        this.$permissionsTemplateButton = $("<td class='permissionsTemplateButton'>");
        this.$permissionsTemplateButtonText = $("<div class='permissionsTemplateButtonText'>");
        this.$permissionsTemplateButtonText.text(this.permissionsTemplateName);
        this.$permissionsTemplateButton.append(this.$permissionsTemplateButtonText);
        this.$permissionsTemplateButton.append($("<span class='permissionsTemplateButtonArrow'>&nbsp;</span>"));
        var errorTextsMap = {};
        this._addCallbackToPermissionsTemplateButton();
        errorTextsMap[ATInviteSeveralUsersRow.prototype.CONCURRENTLY_DELETED_TEMPLATE_ERROR] = messageResource.getMessage("user.js.invite_several_users.error.template_not_exists");
        this._addErrorTooltipCallbacks(this.$permissionsTemplateButton, errorTextsMap);
        this.$row.append(this.$permissionsTemplateButton);

        return this;
    },

    _addCallbackToPermissionsTemplateButton: function()
    {
        var self = this;
        this.$permissionsTemplateButton.click(function()
                                              {
                                                  self.templatesDropdownList.setCallbackHandler(
                                                          {
                                                              onShow: function()
                                                              {
                                                                  self.$permissionsTemplateButton.addClass("active");
                                                              },
                                                              onRowClick: function(templateData)
                                                              {
                                                                  self.setTemplateName({
                                                                      templateId: templateData.id,
                                                                      templateName: templateData.name,
                                                                  })
                                                                  self.errors[ATInviteSeveralUsersRow.prototype.CONCURRENTLY_DELETED_TEMPLATE_ERROR] = false;
                                                                  self.updateUI();
                                                                  if (self.validationCallback)
                                                                  {
                                                                      self.validationCallback();
                                                                  }
                                                                  if (self.changesCallback)
                                                                  {
                                                                      self.changesCallback();
                                                                  }
                                                              },
                                                              onHide: function()
                                                              {
                                                                  self.$permissionsTemplateButton.removeClass("active");
                                                              }
                                                          });
                                                  self.templatesDropdownList.showAt(self.$permissionsTemplateButton);
                                              });
    },

    getUserFields: function()
    {
        var result = InviteSeveralUsersRow.prototype.getUserFields.call(this);
        result.permissionsTemplateId = this.permissionsTemplateId;
        return result;
    },

    updateUI: function()
    {
        InviteSeveralUsersRow.prototype.updateUI.call(this);
        this.$permissionsTemplateButtonText.text(this.permissionsTemplateName);
    },

    addServerErrors: function(errors)
    {
        var self = this;
        _.each(errors, function(error)
        {
            switch (error)
            {
                case "com.actimind.common.services.UserEmailInvalidException":
                    self.errors[InviteSeveralUsersRow.prototype.INVALID_EMAIL_ERROR] = true;
                    break;
                case "com.actimind.actitime.services.PermissionsTemplateNotExistException":
                    self.errors[ATInviteSeveralUsersRow.prototype.CONCURRENTLY_DELETED_TEMPLATE_ERROR] = true;
                    break;
            }
        });
    },

    setTemplateName: function({templateId, templateName}) {
        this.permissionsTemplateId = templateId
        this.permissionsTemplateName = templateName +
                                       (templateId === this.defaultPermissionsTemplateId ?
                                       " " + messageResource.getMessage('userlist.userdata.permissions_templates.js.menu.row.default_template') : "")

    }
});

export default ATInviteSeveralUsersRow



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/ATInviteSeveralUsersRow.js